import React from 'react';
import { CountryCode } from 'libphonenumber-js';

export interface NumberPadProps {
  id: string;
  className?: any;
  numberTextClassName?: string;
  style?: React.CSSProperties;
  onBackspaceClick?: (callbackValue?: any, event?: any) => any;
  onNumberChange?: (callbackValue?: any, event?: any) => any;
  onEscape?: (callbackValue?: any) => any;
  onCursorPositionChange?: (position: any) => any
  callbackValue?: any;
  number?: string;
  showBackSpace?: boolean;
  disableFocus?: boolean;
  contactName?: string;
  contactCount?: number,
  showContactName?: boolean;
  selectedCountry?: CountryCode;
  showCountryCodePicker?: boolean;
  allowedCallingCodes?: Array<string | number>;
  menuZIndex?: any;
  onCountrySelect?: (countryCode: CountryCode) => any;
}

export enum KeyboardKeys {
  esc = 'Escape',
  backSpace = 'Backspace',
  spaceBar = ' ',
  plus = '+',
  hash = '#',
  asterisk = '*',
  arrowLeft = 'ArrowLeft',
  arrowRight = 'ArrowRight',
}
